/*
 * @Author: liujunhong
 * @Date: 2023/7/3
 * @Desc: Layout
 */

import React, { useState } from 'react';
import { Foot, Header } from 'gyyx-component-lib';
import { Outlet } from 'react-router-dom';
import { LoginInfo } from '@/types';
import { useAtomValue } from 'jotai';
import { loginAtom } from '@/utils/atoms';
import { MAP_SITE_URL } from '@/constants';


const Layout = () => {
  const [loginInfo, setLoginInfo] = useState({} as LoginInfo);
  const updateLogin = useAtomValue(loginAtom);


  const onLoginStatus = (res: LoginInfo) => {
    setLoginInfo(res);
  };


  const onLoginSuccess = () => {
    setTimeout(() => {
      window.location.href = MAP_SITE_URL.WWW_URL;
    }, 0);
  };


  return <div>
    <Header updateLogin={updateLogin} loginMode="MergeLogin" onLoginSuccess={onLoginSuccess} onlyWeGame
            onLoginStatus={onLoginStatus}/>
    <Outlet context={loginInfo}/>
    <Foot footId="shequ"/>
  </div>;
};
export default Layout;
